import { Icon } from '@dynamic/ui';
import styled from 'styled-components';

import { remify } from '#/service/utils';

import { Button } from '../Button/Button';
import { FillDiv } from '../FillDiv';
import { lineClamp, LineClampText } from '../LineClampText';
import { fadeInAnimation } from '../styles';

export const OverlayDiv = styled(FillDiv)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  z-index: 100;
`;
OverlayDiv.displayName = 'OverlayDiv';

export const Dialog = styled.dialog`
  /* reset dialog's default styles */
  all: unset;
  display: block;
  width: 40%;
  min-width: min(35rem, 90%);
  max-width: ${remify(1000)};
  box-sizing: border-box;
  padding: 0 1.5rem;
  text-align: center;
  margin: auto 0;
`;

Dialog.displayName = 'Dialog';

export const StatusIcon = styled(Icon)`
  height: ${remify(104)};
  width: auto;
`;
StatusIcon.displayName = 'StatusIcon';

export const StatusTitle = styled.h2`
  margin: 1rem 0;
  color: ${({ color }) => color};
  ${lineClamp(2)};

  /*
  this should be using MEDIA_QUERIES.xl from useResponsiveValues
  see issue https://accedobroadband.jira.com/browse/ONEWEB-2880
  */
  @media (width <= 1200px) {
    ${lineClamp(3)}
  }
`;
StatusTitle.displayName = 'StatusTitle';

export const StatusMessage = styled(LineClampText)`
  word-wrap: break-word;
`;

export const DialogButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
DialogButtonContainer.displayName = 'DialogButtonContainer';

export const DialogButton = styled(Button)`
  display: initial;
  margin: 0.5rem 0;
  width: 50%;

  @media (width <= 400px) {
    width: 100%;
  }
`;
DialogButton.displayName = 'DialogButton';

export const BackContainer = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: -1;
`;
BackContainer.displayName = 'BackContainer';

export const BackImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  &[data-apply-gradient='true'] {
    mask-image: linear-gradient(to top, transparent, var(--pageBackground));
  }

  animation: ${fadeInAnimation} 0.3s ease-in;
`;
BackImage.displayName = 'BackImage';

export const DeveloperContainer = styled.div`
  gap: ${remify(8)};
  text-align: center;
  padding: 0 1.5rem ${remify(50)} 1.5rem;

  & > p {
    margin: 0;
  }
`;

export const DeveloperText = styled.p`
  font: var(--fontStyleFootnote);
  color: var(--pageParagraphForeground);
`;

export const DeveloperSubText = styled(LineClampText)`
  font: var(--fontStyleCaption1);
  color: var(--pageParagraphForeground);
`;
